import { NotImplementedError } from "@baseline/common/errors";
import * as runtime from "../module";
import { HotModuleReplacement } from "./hmr";


export namespace Webpack
{
    export interface Module extends runtime.Module
    {
        hot?: HotModuleReplacement;
        exports: Record<string, any>;
        moduleType?: string;
    }
}

export type Module = Webpack.Module;


declare var __webpack_module_cache__: Record<string, Module>;
declare var __webpack_module_handlers__: ModuleEventHandler[];


export namespace Module
{
    export function getMainModule(): Module
    {
        throw new NotImplementedError();
    }

    export function getModule(id: string): Module
    {
        return __webpack_module_cache__[id];
    }

    export function getModules(replaced?: boolean): Module[]
    {
        if (replaced)
            return modules;
        return __webpack_module_cache__ && Object.values(__webpack_module_cache__);
    }

    export function getExportModules($export: object, replaced?: boolean): Module[]
    {
        let modules = getModules(replaced);
        modules = modules.filter(module => !!module.exports);
        modules =
            modules.filter(
                module =>
                    Object.values(module.exports)
                        .includes($export)
            );
        return modules;
    }

    export function getExportName(module: Module, $export: object): string
    {
        const entry =
            Object.entries(module.exports)
                .find(([, value]) => value == $export);
        const [name] = entry ?? [];
        return name;
    }

    export function on(event: runtime.Event, handler: ModuleEventHandler): typeof Module
    {
        handlers.push(handler);
        return Module;
    }

    export function off(event: runtime.Event, handler: ModuleEventHandler): typeof Module
    {
        handlers = handlers.filter(item => item != handler);
        return Module;
    }


    function onModuleLoad(module: Module): void
    {
        modules.push(module);
        for (const handler of handlers)
            handler(module);
    }

    let handlers: ModuleEventHandler[] = [];

    const modules: Module[] = [];

    __webpack_module_handlers__.push(onModuleLoad);

    function references(): void
    {
        const { id, loaded } = module;
    }
}


export type Event = runtime.Event;


export type ModuleEventHandler = (module: Module) => void;


declare global
{
    namespace NodeJS
    {
        interface Module extends Webpack.Module
        {
        }
    }
}
